import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as modules from "../../constants/modules";
import * as componentTypes from "../../constants/componentTypes";
import * as tooltipHelper from "../../helpers/tooltipHelper";

import UniversalKeyboard from "../global/UniversalKeyboard";

import imgMessage from "../../resources/img/svgicons/message.svg";

export default class SimpleFooter extends Component {
    handleShowNotificationPanelClick = () => {
        this.props.showNotificationPanel();
    };

    getFlashMessageBadgeNumber = () => {
        if (this.props.flashMessages.length > 99) {
            return "99+";
        }

        if (this.props.flashMessages.length > 0) {
            return String(this.props.flashMessages.length);
        }

        return "";
    };

    getFlashMessageBadge = () => {
        if (this.props.flashMessagesStatus === null) {
            return null;
        }

        if (this.props.flashMessagesStatus === componentTypes.FLASH_MESSAGE_ERROR) {
            return <div className="messages-badge error">{this.getFlashMessageBadgeNumber()}</div>;
        }

        return <div className="messages-badge">{this.getFlashMessageBadgeNumber()}</div>;
    };

    getVersion = () => {
        if (this.props.buildVersion === modules.BUILD_NIGHTLY) {
            return (
                <span
                    className="nb-version"
                    data-text={translate("general.revision") + " " + this.props.softwareRevision}
                    onMouseEnter={tooltipHelper.createTooltip}
                >
                    <Translate value="general.version" /> {this.props.clientVersion} {modules.NIGHTLY_BUILD_LABEL}
                </span>
            );
        }

        return (
            <span
                data-text={translate("general.revision") + " " + this.props.softwareRevision}
                onMouseEnter={tooltipHelper.createTooltip}
            >
                <Translate value="general.version" /> {this.props.clientVersion}
            </span>
        );
    };

    getActiveDatabase = () => {
        if (this.props.activeDatabase === null) {
            return "";
        }

        return (
            <span className="pull-right">
                <Translate value="general.database" />
                :&nbsp;{this.props.activeDatabase.name}
            </span>
        );
    };

    getMessagesIcon = () => {
        if (this.props.initialized || this.props.connected === false) {
            if (this.props.active || this.props.flashMessagesStatus !== null) {
                return (
                    <div className="messages" onClick={this.handleShowNotificationPanelClick}>
                        <ReactSVG src={imgMessage} className="message-img" alt="message" wrapper="span" />
                        {this.getFlashMessageBadge()}
                    </div>
                );
            }

            return (
                <div className="messages disabled">
                    <ReactSVG src={imgMessage} className="message-img" alt="message" wrapper="span" />
                </div>
            );
        }

        return null;
    };

    render() {
        if (this.props.virtualKeyboardSupport) {
            return (
                <div className="footer" style={{WebkitAppRegion: "no-drag"}}>
                    {this.getVersion()}
                    <UniversalKeyboard />
                    <div className="flex-right">
                        {this.getActiveDatabase()}
                        {this.getMessagesIcon()}
                    </div>
                </div>
            );
        }

        return (
            <div className="footer" style={{WebkitAppRegion: "no-drag"}}>
                {this.getVersion()}
                <div className="flex-right">
                    {this.getActiveDatabase()}
                    {this.getMessagesIcon()}
                </div>
            </div>
        );
    }
}
